module.exports = __webpack_public_path__ + "static/media/icEditBanner.db8b18bb.svg";